import { createContext } from "react";

const supTabValidation = { isValidate: () => {}, isSubtap: false };
const formValidation = { isValidate: () => {} };
const cancelfunction = { cancelFun: () => {} };
const popupfunction = { nextFun: () => {} };
export const UserContext = createContext({
  supTabValidation,
  formValidation,
  cancelfunction,
  popupfunction,
});
